import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FastAPIService } from '../service/fast-api.service';

@Component({
  selector: 'app-analysis-display',
  templateUrl: './analysis-display.component.html',
  styleUrls: ['./analysis-display.component.scss']
})
export class AnalysisDisplayComponent implements OnInit{
  topic: string | null = ""
  images: string[] = [];
  detail: string | null = "";

  routerSubscribe: Subscription;

  constructor(private fastService: FastAPIService, private route: ActivatedRoute, private router: Router) {
    this.routerSubscribe = this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd && event.url.split(';')[0] == '/analysis-display') {
        this.reloadData();
      }
    })
  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.routerSubscribe.unsubscribe();
  }

  reloadData() {
    this.topic = this.route.snapshot.paramMap.get('topic');
    const image = this.route.snapshot.paramMap.get('image');
    if(image) this.images.push(image)
    this.detail = this.route.snapshot.paramMap.get('detail');
  }
}
